import React, { Component } from 'react';
import { connect } from 'formik';
import Input from '../../components/input/text/input-formik';
import { IProfileProps, IOuterProps } from '../../models/components/profile';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { SecureImage } from '../../components/core/secureImage';
import { Common } from '../../core/common';
import Moment from 'moment';
import { DatetimeFormik } from '../../components/input/date-time/date-time-formik';
import Switch from 'react-switch';
import TwoFactorMail from './two-factor-mail';
import TwoFactorVerification from './two-factor-verification';
import { SelectNoneAsync } from '../../components/input/select/main';
import { Notification } from '../../components/notification/main';

const T = Translator.create();
const _logger = Log.create('personal-information');
let _common: Common;

export class PersonalInformation extends Component<IProfileProps> {
    public constructor(props: any) {
        super(props);
        _common = new Common();
    }
    state = {
        twoFactorStatus: false,
        twoFactorModelStatus: false,
        twoFactorModelVerificationStatus: false,
        timezoneOptions: this.props.timezoneData || []
    };

    componentDidMount(): void {
        if (this.props.formik.values.twoFactorAuthMailAddress?.length > 0) {
            this.props.formik.setFieldValue("twoFactorAuthMailAddress_checked", this.props.formik.values.twoFactorAuthMailAddress)
        }
        this.setState({ twoFactorStatus: this.props.formik.values.isTwoFactorAuthOpen && this.props.formik.values.isThereTwoFactorAuth })

    }

    componentDidUpdate(prevProps: Readonly<IProfileProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if (prevProps.timezoneData !== this.props.timezoneData) {
            this.setState({ timezoneOptions: this.props.timezoneData });
        }
        if (this.props.formik.values.isTwoFactorAuthOpen !== prevProps.formik.values.isTwoFactorAuthOpen)
            this.setState({ twoFactorStatus: this.props.formik.values.isTwoFactorAuthOpen })

    }

    onChangeSwitch = (checked: any) => {
        this.setState({ twoFactorStatus: !checked });
    };
    onClickTwofactorModel = (status: any) => {
        if (!this.props.formik.values.twoFactorAuthMailAddress && status)
            this.props.formik.setFieldValue("twoFactorAuthMailAddress", this.props.formik.values.email)
        this.setState({ twoFactorModelStatus: status });
    };

    onClickTwofactorVerificationModel = (status: any) => {
        this.setState({ twoFactorModelVerificationStatus: status });
    };

    handleSendVerificationCode = (email: string, isEmailAdding: boolean) => {
        this.props.formik.values.sendVerificationCode(email, isEmailAdding);
    }

    handleReset = () => {
        this.props.formik.values.handleResetError();
    }

    checkVerificationCode = (username: string, verificationCode: string, callback: any) => {
        this.props.formik.values.checkVerificationCode(username, verificationCode, callback);
    }

    onChangeSelect = (event: any, name: any) => {
        this.props.formik.setFieldValue(name, event ? event.value : null)
    }

    validateForm = () : void => {  
        if(this.validateTwoFactorMail())
        {
            this.props.formik.submitForm();
        }
    }

    validateTwoFactorMail = () : boolean => {
        if(this.props.formik.values.isThereTwoFactorAuth && this.props.formik.values.isTwoFactorAuthOpen && (this.props.formik.values.twoFactorAuthMailAddress === "" || this.props.formik.values.twoFactorAuthMailAddress_checked === ""))
        {
           Notification.setNotification(
               'error',
                T.t('r_two_factor_email_error'),
                'topRight'
            );
           return false;
        }
        return true;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-md-9">
                    <h5>{T.t('r_personal_info')}</h5>
                    <div className="row">
                        <div className="col-md-6">
                            <Input type={'text'} name={'firstName'} label={T.t('r_firstname')} formik={this.props.formik} />
                        </div>
                        <div className="col-md-6">
                            <Input type={'text'} name={'lastName'} label={T.t('r_lastname')} formik={this.props.formik} />
                        </div>
                    </div>
                    <Input disable={true} type={'text'} name={'userName'} label={T.t('r_username')} formik={this.props.formik} />
                    <Input type={'text'} name={'email'} label={T.t('r_email_adress')} formik={this.props.formik} />
                    <Input  noLetters = {true} type={'text'} name={'mobilePhone'} label={T.t('r_phone_number')} formik={this.props.formik} />
                    <Input
                        type={'text'}
                        name={'citizenshipIdentifier'}
                        label={T.t('r_turkish_identity_number')}
                        formik={this.props.formik}
                    />
                    <DatetimeFormik
                        name={'birthDateFormatted'}
                        placeHolder={T.t('r_birthdate')}
                        formik={this.props.formik}
                        datePickerId={'birthDateFormatted'}
                        mode="single"
                        time24Hr={true}
                        dateFormat={this.props.formik.values.dateFormat}
                        static={true}
                        maxDate={new Date()}
                    />
                    <Input type={'text'} name={'job'} label={T.t('r_job')} formik={this.props.formik} />
                    <Input
                        disable={true}
                        type={'text'}
                        name={'organizationName'}
                        label={T.t('r_institution_information')}
                        formik={this.props.formik}
                    />

                    <div className='mt-3 mb-5'>
                        <span>{T.t('timezone')}</span>
                        <SelectNoneAsync
                            name={'timeZone'}
                            setFieldValue={this.props.formik.setFieldValue}
                            setOptions={this.state.timezoneOptions}
                            onChange={this.onChangeSelect}
                            isTouched={this.props.formik.setFieldTouched}
                            setSelectValue={this.props.formik.values.timeZone ? [this.props.formik.values.timeZone] : ''}
                            placeHolder={T.t('r_make_select')}
                        />
                    </div>

                    <h5>{T.t('r_safety_information')}</h5>
                    <div className="d-table row mb-4">
                        <div className="d-table-cell col-md-6">
                            <Input
                                className={'form-input form-group mb-0'}
                                type={'password'}
                                name={'password'}
                                label={T.t('r_password')}
                                value={'123456789'}
                                formik={this.props.formik}
                                render={
                                    this.props.formik.values.lastPasswordChangeDate == null ? (
                                        <small></small>
                                    ) : (
                                        <small>
                                            {T.t('r_last_modified')}
                                            {Moment(this.props.formik.values.lastPasswordChangeDate).format('LLL')}
                                        </small>
                                    )
                                }
                            />
                        </div>
                        <div className="d-table-cell col-md-6">
                            {/* tslint:disable-next-line */}
                            <button
                                type="button"
                                data-toggle="modal"
                                data-target="#change-password"
                                className="category-tag-square tag-gray password-change-width"
                            >
                                <i className="material-icons mr-2">sync</i> {T.t('r_change_password')}
                            </button>
                        </div>
                    </div>

                    <div className="d-table row mb-4">
                        <div className="d-table-cell col-md-8">
                            <Input
                                className={'form-input form-group mb-0'}
                                type={'password'}
                                name={'securityQuestion'}
                                label={T.t('r_security_question_answer')}
                                value={'123456789'}
                                formik={this.props.formik}
                                render={
                                    this.props.formik.values.lastPasswordChangeDate == null ? (
                                        <small></small>
                                    ) : (
                                        <small>
                                            {T.t('r_last_modified')}
                                            {Moment(this.props.formik.values.lastPasswordChangeDate).format('L')}
                                        </small>
                                    )
                                }
                            />
                        </div>
                        <div className="d-table-cell col-md-4">
                            <button
                                style={{ display: 'none' }}
                                type="button"
                                data-toggle="modal"
                                data-target="#change-password-question"
                                className="category-tag-square tag-gray"
                            >
                                <i className="material-icons mr-2">sync</i> {T.t('r_update')}
                            </button>
                        </div>
                    </div>
                    {
                        this.props.formik.values.isThereTwoFactorAuth &&
                        <div className="d-table row mb-2">
                            <div className="d-table-cell col-md-9">
                                <h5>{T.t('r_use_two_factor')}</h5>
                            </div>
                            <div className="d-table-cell col-md-3">
                                <label className="switch">

                                    <Switch
                                        id={'isTwoFactorAuthOpen'}
                                        name={'isTwoFactorAuthOpen'}
                                        onChange={(e: any) => this.props.formik.setFieldValue('isTwoFactorAuthOpen', e)}
                                        checked={this.props.formik.values.isTwoFactorAuthOpen ?? false}
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        onColor="#319b6b"
                                        className="react-switch react-switch-margin"
                                        height={20}
                                        width={38}
                                    />
                                </label>
                                <span>{this.props.formik.values.isTwoFactorAuthOpen ? T.t('r_yes') : T.t('r_no')}</span>

                            </div>
                        </div>
                    }

                    {this.props.formik.values.isTwoFactorAuthOpen && this.props.formik.values.isThereTwoFactorAuth && (
                        <div className="d-table row mb-4">
                            <div className="d-table-cell col-md-9">
                                {/* tslint:disable-next-line */}
                                {
                                    this.props.formik.values.twoFactorAuthMailAddress_checked && this.props.formik.values.twoFactorAuthMailAddress_checked.length > 0 ?
                                        <div className="d-table row mb-4">
                                            <div className="d-table-cell col-md-9">
                                                <Input
                                                    type={'text'}
                                                    name={'twoFactorAuthMailAddress_checked'}
                                                    label={T.t('r_email_adress')}
                                                    formik={this.props.formik}
                                                />
                                            </div>
                                            <div className="d-table-cell col-md-9">
                                                {/* tslint:disable-next-line */}
                                                <button
                                                    type="button"
                                                    onMouseDown={e => this.onClickTwofactorModel(true)}
                                                    className="category-tag-square tag-gray password-change-width"
                                                >
                                                    <i className="material-icons mr-2">sync</i> {T.t('r_update')}
                                                </button>
                                            </div>
                                        </div>
                                        :
                                        <button
                                            type="button"
                                            onMouseDown={e => this.onClickTwofactorModel(true)}
                                            className="category-tag-square tag-gray password-change-width"
                                        >
                                            <i className="material-icons mr-2">sync</i> {T.t('r_add_two_factor_address')}
                                        </button>
                                }

                            </div>
                        </div>
                    )}
                    {this.state.twoFactorModelStatus && (
                        <TwoFactorMail formik={this.props.formik} onClickTwofactorModel={this.onClickTwofactorModel} sendVerificationCode={this.handleSendVerificationCode} checkVerificationCode={this.checkVerificationCode} resetErrorMessage={() => this.handleReset()} />
                    )}
                    <div className="social-footer">
                        <div className="activity-footer d-flex justify-content-between">
                            <div className="mini-btn">
                                {/* tslint:disable-next-line */}
                                <button onClick={() => this.props.formik.resetForm()} type="button" className="btn btn-gray min-auto">
                                    <i className="material-icons">clear</i> {T.t('r_cancel_button')}
                                </button>
                            </div>
                            <div className="mini-btn text-md-right">
                                {/* tslint:disable-next-line */}
                                <button onClick={() => this.validateForm()} type="button" className="btn btn-green min-auto">
                                    <i className="material-icons icon-rtl">done</i> {T.t('r_save_button')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 text-center ">
                    <a className="cursor-pointer d-block" data-toggle="modal" data-target="#update-image-modal">
                        <SecureImage
                            class={'userProfile mt-3'}
                            style={{ maxWidth: '100%' }}
                            imageUrl={this.props.formik.values.profileImagePath}
                            preventCaching={true}
                        />
                    </a>
                </div>
            </div>
        );
    }
}

export default connect<IProfileProps, IOuterProps>(PersonalInformation);
